/**
 * Who the signed-in person is, in the words the interface greets them with.
 *
 * Extracted from SystemAdminDashboard once the mobile app header needed the same two
 * values. Both now read from here, so "Good morning" cannot start at 11 in one place
 * and noon in another.
 */

/** Time-of-day greeting, from the viewer's own clock. */
export function greeting(now: Date = new Date()): string {
  const hour = now.getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

/**
 * The name to greet someone by.
 *
 * An account with no employee record — a bootstrap super admin — has no full name, so
 * the local part of the email stands in rather than leaving the greeting dangling.
 */
export function firstNameOf(
  user: { employee?: { fullName?: string | null } | null; email?: string | null } | null | undefined,
  fallback = 'there',
): string {
  const fromEmployee = user?.employee?.fullName?.trim().split(/\s+/)[0];
  if (fromEmployee) return fromEmployee;

  const fromEmail = user?.email?.split('@')[0];
  if (fromEmail) return fromEmail;

  return fallback;
}

/** "Tuesday, 4 November" — the date line under a greeting. */
export function todayLabel(now: Date = new Date()): string {
  return now.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}
